var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-section',{attrs:{"title":_vm.$t('Integrations_Overview_Information')}},[_c('form-section',[_c('b',[_vm._v(_vm._s(_vm.$t('Integrations_Field_WebhookUrl')))]),_vm._v("\n    : "+_vm._s(_vm.model.params.url)+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23c05cda","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/integrations/types/opapwebhook/OpapWebhookOverview.vue
// module id = null
// module chunks = 